/*
 * Filename: panel.js
 * Responsible all cmponent with headding
 * and child components
 */

import React, { Component } from 'react';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import classNames from 'classnames';
import { connect } from 'react-redux';

const styles = {
  font: {
    fontStyle: 'ITALIC',
  },
};

class FinancialKPIPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,    
    };
  }
  
  handleOnRequestChange = (e,value) => {
    let financialKPItitle = "Open A/R Expected Amounts";
    let financialKPIsubtitle = "*This chart displays values based on allowed/expected amounts.";
    
    if(value === 'Open A/R Expected Amounts')
    {
      financialKPItitle = "Open A/R Expected Amounts";
      financialKPIsubtitle = "*This chart displays values based on allowed/expected amounts.";
    } 
    else if(value === 'Open Claims by Status')
    {
      financialKPItitle = "Open Claims by Status";
      financialKPIsubtitle = "*This chart displays values based on allowed/expected amounts.";
    }
    else if(value === 'Payments Collected')
    {
      financialKPItitle = "Payments Collected";
      financialKPIsubtitle = "*This chart is based on payment/check dates in the system.";
    }
    else if(value === 'Collection Rate')
    {
      financialKPItitle = "Collection Rate";
      financialKPIsubtitle = "*This chart displays values based on allowed/expected amounts.";
    }
    else if(value === 'Staff Billing')
    {
      financialKPItitle = "Staff Billing";
      financialKPIsubtitle = "*This chart displays values based on allowed/expected amounts.";
    }
    else if(value === 'Amount Billed')
    {
      financialKPItitle = "Amount Billed";
      financialKPIsubtitle = "*This chart displays values based on submitted billed amounts.";
    }
    else if(value === 'Profit Analysis')
    {
      financialKPItitle = "Profit Analysis";
      financialKPIsubtitle = "*This chart displays values based on allowed/expected amounts.Please click generate after you have selected the appropriate filters.";
    }
    
    this.props.handlechangeFinancialKPI(financialKPItitle,financialKPIsubtitle);
  }

  render() {
    const panelClass = classNames ({
      'readmin-panel' : true,
      'righticonmenu': true,
      'body-text-center': this.props.center
    });

    // let { userImage, welcomeNote } = this.props;
    return (
      <div className={panelClass}>
        <div className="panel-mainheading">
          <h5>Financial Graphs</h5>
        </div>
        <div className="panel-heading panel-heading-withsubtitle">
          <h5>{this.props.financialKPItitle}</h5>
          {/* <h7>{props.financialKPIsubtitle}</h7> */}
          {/* <div className="panel_title_billablekpi"> */}
            {/* <h7 style={styles.font}>{this.props.financialKPIsubtitle}</h7> */}
          {/* </div> */}
          { this.props.righticon ? 
            <IconMenu
              //{...props}
              iconButtonElement={
              <IconButton><i className="material-icons">more_vert</i></IconButton>
              }
              targetOrigin={{horizontal: 'right', vertical: 'top'}}
              anchorOrigin={{horizontal: 'right', vertical: 'top'}}
            >
              <MenuItem primaryText="Open A/R Expected Amounts" onClick={(e) => this.handleOnRequestChange(e,'Open A/R Expected Amounts')}/>
              <MenuItem primaryText="Open Claims by Status" onClick={(e) => this.handleOnRequestChange(e,'Open Claims by Status')}/>
              <MenuItem primaryText="Payments Collected" onClick={(e) => this.handleOnRequestChange(e,'Payments Collected')}/>
              <MenuItem primaryText="Collection Rate" onClick={(e) => this.handleOnRequestChange(e,'Collection Rate')}/>
              <MenuItem primaryText="Staff Billing" onClick={(e) => this.handleOnRequestChange(e,'Staff Billing')}/>      
              <MenuItem primaryText="Amount Billed" onClick={(e) => this.handleOnRequestChange(e,'Amount Billed')}/>              
              <MenuItem primaryText="Profit Analysis" onClick={(e) => this.handleOnRequestChange(e,'Profit Analysis')}/>              
              {/* <MenuItem primaryText="List 4" /> */}
            </IconMenu>
          : null}
        </div>
        <div className="panel_title_billablekpi">
          <h7 style={styles.font}>{this.props.financialKPIsubtitle}</h7>
        </div>
        <div className="panel-body">
          {this.props.children}
        </div>
      </div>
    ); 
  }
}
const mapStateToProps = (state) => {
  return {
    loginUserInfo: state.login.loginUserInfo, 
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
};

export default connect(mapStateToProps, { })(FinancialKPIPanel);




// WEBPACK FOOTER //
// ./src/adminCharts/FinancialKPIPanelToolTip.js